<div fxLayout="row" fxLayoutAlign="end center">
  <mat-icon class="closeDialogHandler" (click)="closeDialog()">close</mat-icon>
</div>
<div class="privacyContent">
  <iframe src="https://www.athenscollege.edu.gr/privacy-notice" width="100%" height="100%"></iframe>
</div>
